import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { wxBindApi } from '../apis/admin'


export default /*@__PURE__*/_defineComponent({
  __name: 'BindWxDialog',
  setup(__props, { expose: __expose }) {

const wxQrDialog = ref<Boolean>(false) // 弹框状态
const qrcode = ref<String>('') // 二维码图片地址

// 商户绑定微信，以方便消息推送
const openWxQrDialog = async () => {
    const { code, data, msg } = await wxBindApi() as any
    if (code != 200) { return ElMessage({ type: 'error', message: msg }) }
    
    // 只允许绑定三个微信号
    if (!data.url) {
        return ElMessage({ type: 'error', message: '一个二维码只可绑定三个微信号，如有问题可解绑或更换绑定' })
    }
    qrcode.value = data.url
    wxQrDialog.value = true
}

// 暴露方法
__expose({
    openWxQrDialog
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "wx-dialog",
    title: "绑定微信",
    modelValue: wxQrDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((wxQrDialog).value = $event))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (wxQrDialog.value = false))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, [
        _createTextVNode("请扫码绑定微信，方便日后接收订单提醒"),
        _createElementVNode("span", { style: {"font-size":"14px","color":"red"} }, "（确保已关注蛋糕叔叔公众号）")
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "msg" }, "注：一个二维码只可绑定三个微信号，如有问题可解绑或更换绑定", -1)),
      _createVNode(_component_el_image, {
        class: "qrcode",
        src: qrcode.value,
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})